import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Loader from "@/components/Loader";
import { BookOpen } from "lucide-react";

export default function Articles() {
  const [articles, setArticles] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/public/articles").then(({ data }) => setArticles(data.articles || [])).catch(() => setArticles([])); }, []);
  if (!articles) return <Loader />;
  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="text-3xl md:text-4xl font-heading font-extrabold mb-2">Articles & Resources</h1>
      <p className="text-thali-ink/70 mb-8">Guides on PM POSHAN rates, menus and record-keeping for Odisha schools.</p>
      <div className="grid sm:grid-cols-2 gap-5">
        {articles.map((a) => (
          <div key={a.id} className="card-thali cursor-pointer hover:-translate-y-1 transition-transform" onClick={() => setOpen(open === a.id ? null : a.id)} data-testid={`article-${a.id}`}>
            <div className="w-11 h-11 rounded-xl bg-thali-green/10 text-thali-green grid place-items-center mb-3"><BookOpen className="w-5 h-5" /></div>
            <h3 className="font-heading font-bold text-lg mb-1">{a.title}</h3>
            <p className="text-sm text-thali-ink/70">{a.excerpt}</p>
            {open === a.id && <p className="mt-3 text-sm text-thali-ink border-t border-thali-turmeric/20 pt-3">{a.body}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
